import React, { Component } from "react";
import domain from ".././../../../domain";
import axios from "axios";
import { Row, Col, Card, CardBody } from "mdbreact";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import moment from "moment";
export default class OverallFeedbackReport extends Component {
  constructor() {
    super();
    this.state = {
      feedback: null,
      course_title: null,
      start_date: null,
      end_date: null,
    };
  }
  componentDidMount() {
    this.getOverallFeedback();
    this.getCourseDetails();
  }
  async getCourseDetails() {
    let id = this.props.match.params.id;
    let result = await axios.get(`${domain.DBServer}/fetch-course/${id}`);
    this.setState({
      course_title: result.data[0].title,
      start_date: result.data[0].start_date,
      end_date: result.data[0].end_date,
    });
  }
  getOverallFeedback() {
    let id = this.props.match.params.id;
    console.log(id);
    axios
      .get(`${domain.DBServer}/fetch-overall-feedback/${id}`)
      .then((result) => {
        this.setState({ feedback: result.data });
        console.log(result.data);
      })
      .catch((err) => console.log(err));
  }

  render() {
    const feedback = this.state.feedback;

    let feedbackTable,
      totalclarity = 0,
      totalobj = 0,
      totallearn = 0,
      totalfac = 0,
      totaldemo = 0,
      totalmat = 0,
      totalov = 0,
      totalavg = 0;
    let commentTable;
    let avg,
      totalrows = 0;
    if (feedback) {
      feedbackTable = feedback.map((response, key) => {
        avg =
          (parseInt(response.feedback.clarity, 10) +
            parseInt(response.feedback.objective, 10) +
            parseInt(response.feedback.learning, 10) +
            parseInt(response.feedback.faculty, 10) +
            parseInt(response.feedback.demonstration, 10) +
            parseInt(response.feedback.coursematerial, 10) +
            parseInt(response.feedback.overall, 10)) /
          7;
        totalrows = totalrows + 1;
        totalavg += avg;

        totalclarity += parseInt(response.feedback.clarity, 10);
        totalobj += parseInt(response.feedback.objective, 10);
        totaldemo += parseInt(response.feedback.demonstration, 10);
        totalfac += parseInt(response.feedback.faculty, 10);
        totallearn += parseInt(response.feedback.learning, 10);
        totalmat += parseInt(response.feedback.coursematerial, 10);
        totalov += parseInt(response.feedback.overall, 10);

        return (
          <tr key={key}>
            {/* {console.log(course.course_id)} */}
            <th scope="row">{key + 1}</th>
            <td>
              {response.name}
              {/* <Popover
                      component="badge"
                      placement="right"
                      popoverBody="info"
                      className="badge badge-pill indigo">
                      <PopoverHeader>{response.name}</PopoverHeader>
                      <PopoverBody>{response.designation}<br/>{response.organization}<br/>{response.department}<br/>{response.t_state}<br/>{response.mobile}<br/>{response.email}</PopoverBody>
                    </Popover> */}
            </td>
            <td style={{ textAlign: "right" }}>{response.feedback.clarity}</td>
            <td style={{ textAlign: "right" }}>
              {response.feedback.objective}
            </td>
            <td style={{ textAlign: "right" }}>{response.feedback.learning}</td>
            <td style={{ textAlign: "right" }}>{response.feedback.faculty}</td>
            <td style={{ textAlign: "right" }}>
              {response.feedback.demonstration}
            </td>
            <td style={{ textAlign: "right" }}>
              {response.feedback.coursematerial}
            </td>
            <td style={{ textAlign: "right" }}>{response.feedback.overall}</td>
            {/* <td>{response.feedback.comment}</td> */}

            <td style={{ textAlign: "right", fontWeight: "bold" }}>
              {Number(avg).toFixed(2)}
            </td>
          </tr>
        );
      });
    }
    if (feedback) {
      commentTable = feedback.map((response, key) => {
        return (
          <tr key={key}>
            {/* {console.log(course.course_id)} */}
            <th scope="row">{key + 1}</th>
            <td>
              {response.name}
              {/* <Popover
                      component="badge"
                      placement="right"
                      popoverBody="info"
                      className="badge badge-pill indigo">
                      <PopoverHeader>{response.name}</PopoverHeader>
                      <PopoverBody>{response.designation}<br/>{response.organization}<br/>{response.department}<br/>{response.t_state}<br/>{response.mobile}<br/>{response.email}</PopoverBody>
                    </Popover> */}
            </td>

            <td>{response.feedback.comment}</td>
          </tr>
        );
      });
    }

    return (
      <Row className="justify-content-md-center">
        <Col md="12">
          <Card>
            {/* <h3 style={{color:"#3f51b5",textAlign:"left", paddingLeft:"20px", paddingTop:"10px"}}>Overall Feedback</h3> */}
            <CardBody>
              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="exportbuttonstyle"
                table="table-to-xls"
                filename={this.props.match.params.id}
                sheet="tablexls"
                buttonText="Export As Excel"
              />
              <table
                id="table-to-xls"
                className="table table-striped table-bordered table-responsive-md"
                cellSpacing="0"
                width="100%"
              >
                <thead
                  style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                >
                  <tr>
                    <th
                      colSpan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h3>{this.state.course_title}</h3>
                    </th>
                  </tr>
                  <tr>
                    <th
                      colSpan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h3 style={{ textAlign: "center", color: "#3f51b5" }}>
                        {moment(this.state.start_date).format("LL")} To{" "}
                        {moment(this.state.end_date).format("LL")}{" "}
                      </h3>
                    </th>
                  </tr>

                  <tr>
                    <th
                      colSpan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h5>Overall Feedback Report</h5>
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">S. No</th>
                    <th scope="col">Trainee Name</th>
                    <th scope="col">Clarity of Course Objective</th>
                    <th scope="col">Whether Objective met</th>
                    <th scope="col">Learning New Concepts</th>
                    <th scope="col">Faculty Presentation Skills</th>
                    <th scope="col">Usefulness of Demonstration</th>
                    <th scope="col">Usefulness of Course material</th>
                    <th scope="col">Overall course evaluation</th>
                    {/* <th scope="col">Comment</th> */}
                    <th scope="col">Average</th>
                    {/* <th scope="col">Average</th> */}
                  </tr>
                </thead>
                <tbody>
                  {feedbackTable}
                  <tr>
                    <td
                      colSpan="2"
                      style={{ textAlign: "center", fontWeight: "bold" }}
                    >
                      Total
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalclarity / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalobj / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totallearn / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalfac / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totaldemo / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalmat / totalrows).toFixed(2)}
                    </td>
                    <td style={{ textAlign: "right", fontWeight: "bold" }}>
                      {Number(totalov / totalrows).toFixed(2)}
                    </td>

                    <td style={{ color: "blue", fontSize: "20px" }}>
                      {Number(totalavg / totalrows).toFixed(2)}
                    </td>
                  </tr>
                </tbody>
              </table>

              <ReactHTMLTableToExcel
                id="test-table-xls-button"
                className="exportbuttonstyle"
                table="table-to-xls1"
                filename={this.props.match.params.id}
                sheet="comments"
                buttonText="Export As Excel"
              />
              <table
                id="table-to-xls1"
                className="table table-striped table-bordered table-responsive-md"
                cellSpacing="0"
                width="100%"
              >
                <thead
                  style={{ textAlign: "center", backgroundColor: "#33b5e5" }}
                >
                  <tr>
                    <th
                      colSpan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h3>{this.state.course_title}</h3>
                    </th>
                  </tr>
                  <tr>
                    <th
                      colSpan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h3 style={{ textAlign: "center", color: "#3f51b5" }}>
                        {moment(this.state.start_date).format("LL")} To{" "}
                        {moment(this.state.end_date).format("LL")}{" "}
                      </h3>
                    </th>
                  </tr>

                  <tr>
                    <th
                      colSpan="10"
                      style={{
                        textAlign: "center",
                        backgroundColor: "#FFFFFF",
                        border: "0",
                        color: "#3f51b5",
                      }}
                    >
                      <h5>Overall Feedback Report with Comments</h5>
                    </th>
                  </tr>
                  <tr>
                    <th scope="col">S. No</th>
                    <th scope="col">Trainee Name</th>

                    <th scope="col">Comment</th>
                  </tr>
                </thead>
                <tbody>{commentTable}</tbody>
              </table>
            </CardBody>
          </Card>
        </Col>
      </Row>
    );
  }
}
